import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  modal: {
    "& .mantine-Modal-body": {
      backgroundColor: "#F5F5F5",
    },
  },
  noticeBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: ".5rem",
    backgroundColor: "#a6f4c580",
    padding: "5px 10px",
    borderRadius: "30px",
    marginTop: "1rem",
    color: "#027A48",
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "Inter",
  },
  notice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
    backgroundColor: "#fff",
    padding: "3px 5px",
    borderRadius: "30px",
    color: "#027A48",
    border: "1px solid #027A48"
  },
  radioGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  radioBox: {
    border: "1px solid #E5E5E5",
    borderRadius: "5px",
    padding: "20px",
    backgroundColor: "#fff",
    // flexBasis: "48%",
    // width: "100%",
  },
  facilityModal: {
    minWidth: "500px",
    height: "300px",
  },
  clockIconParent: {
    textAlign: "center",
  },
  modalHeading: {
    textAlign: "center",
    margin: "5px 0",
    textTransform: "capitalize",
    fontWeight: "500",
  },
  cancelBtn: {
    backgroundColor: "transparent",
    color: "#000000",
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    // width: "47%",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#ffffff",
    },
  },
  action: {
    textTransform: "capitalize",
    borderRadius: "8px",
    backgroundColor: "#FFAF4A",
    // width: "47%",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#000000",
    },
  },
  warn: {
    textAlign: "center",
    color: "#737373",
    fontSize: "large",
    width: "80%",
    margin: "0 auto",
  },
  distanceSection:{
    padding:'.5rem 1rem',
    background:'#fff',
    margin:'1rem 0'
  },
  distanceSectionBox:{
    padding:'1rem .5rem',
    textAlign:'center'
  },
  distance:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',

  },
  iconBox:{
    height:70,
    width:70,
    marginBottom:10,
    borderRadius:'50%',
    alignContent:'center',
    textAlign:'center',
  }
}));

export default useStyles;
